import React, { FC, memo } from 'react';
import { LinearProgressBar } from '@wix/design-system';

type Props = {
  currentStepIndex: number;
  totalSteps: number;
};

export const HeaderProgress: FC<Props> = memo(({ currentStepIndex, totalSteps }) => {
  return <LinearProgressBar value={(currentStepIndex / totalSteps) * 100} />;
});
